let windowObjectReference = null;
let previousUrl = null;

const BASE_URL = process.env.REACT_APP_AUTH_HOST

const receiveMessage = processCredentials => event => {
  // Do we trust the sender of this message? (might be
  // different from what we originally opened, for example).
  if (event.origin !== BASE_URL) {
    return;
  }
  const { data } = event;

  processCredentials(data)
};


export const openSignInWindow = (url, name) => {
  return new Promise((resolve, reject) => {
    // remove any existing event listeners
    window.removeEventListener('message', receiveMessage);

    // window features
    const strWindowFeatures =
      'toolbar=no, menubar=no, width=600, height=800, top=100, left=100';

    if (windowObjectReference === null || windowObjectReference.closed) {
      /* if the pointer to the window object in memory does not exist
       or if such pointer exists but the window was closed */
      windowObjectReference = window.open(url, name, strWindowFeatures);
    } else if (previousUrl !== url) {
      /* if the resource to load is different,
       then we load it in the already opened secondary window and then
       we bring such window back on top/in front of its parent window. */
      windowObjectReference = window.open(url, name, strWindowFeatures);
      windowObjectReference.focus();
    } else {
      /* else the window reference must exist and the window
       is not closed; therefore, we can bring it back on top of any other
       window with the focus() method. There would be no need to re-create
       the window or to reload the referenced resource. */
      windowObjectReference.focus();
    }

    let messageReceived = false;

    if (windowObjectReference) {
      // Use parent focus event instead of polling .closed — providers like
      // Constant Contact set COOP: same-origin which permanently disconnects
      // the window reference, making .closed return true even while the popup
      // is still open. We only check when the parent actually regains focus.
      const handleFocus = async function() {
        try {
          if (windowObjectReference && windowObjectReference.closed) {
            window.removeEventListener('focus', handleFocus);
            if (!messageReceived) {
              // window.opener was severed by provider COOP header — fall back
              // to polling the backend session for the OAuth data.
              try {
                const response = await fetch(`${BASE_URL}/auth/pending_oauth`, {
                  credentials: 'include'
                });
                const data = await response.json();
                if (data) {
                  resolve(data);
                } else {
                  reject();
                }
              } catch {
                reject();
              }
            }
          }
        } catch(e) {
          // ignore cross-origin access errors during OAuth redirect
        }
      };
      window.addEventListener('focus', handleFocus);
    }

    // add the listener for receiving a message from the popup
    window.addEventListener('message', receiveMessage(data => {
      messageReceived = true;
      resolve(data);
    }), false);

    // assign the previous URL
    previousUrl = url;
  })
};
